import { ReactiveFormsModule } from '@angular/forms';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ItemSliderComponent } from './item-slider/item-slider.component';
import { SwiperModule } from 'swiper/angular';
import { RouterModule } from '@angular/router';
import { LoaderComponent } from './loader/loader/loader.component';
import { LiveAuctionComponent } from './live-auction/live-auction.component';
import { AuctionCardComponent } from './auction-card/auction-card.component';
import { TableContentComponent } from './table-content/table-content.component';
import { DataTablesModule } from 'angular-datatables';
import { LaddaModule } from 'angular2-ladda';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { BackButtonComponent } from './back-button/back-button.component';
import { InputMaskModule } from '@ngneat/input-mask';
import { NgSelectModule } from '@ng-select/ng-select';
import { AuctionDetailsHeroSkeletonComponent } from './auction-details-hero-skeleton/auction-details-hero-skeleton.component';
import { AuctionVehicleCardComponent } from './auction-vehicle-card/auction-vehicle-card.component';
import { TimedIndividualAuctionDetailsComponent } from './timed-individual-auction-details/timed-individual-auction-details.component';
import { CutomLoaderComponent } from './loader/cutom-loader/cutom-loader.component';
import { InputLoaderComponent } from './input-loader/input-loader.component';
import { DownArrowComponent } from './down-arrow/down-arrow.component';
import { InfiniteScrollComponentComponent } from './infinite-scroll-component/infinite-scroll-component.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

@NgModule({
  declarations: [
    ItemSliderComponent,
    LoaderComponent,
    LiveAuctionComponent,
    AuctionCardComponent,
    TableContentComponent,
    BackButtonComponent,
    AuctionDetailsHeroSkeletonComponent,
    AuctionVehicleCardComponent,
    TimedIndividualAuctionDetailsComponent,
    CutomLoaderComponent,
    InputLoaderComponent,
    DownArrowComponent,
    InfiniteScrollComponentComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    SwiperModule,
    DataTablesModule,
    ReactiveFormsModule,
    LaddaModule.forRoot({
      style: 'slide-up',
      spinnerSize: 30,
      spinnerColor: '#F9B22C',
      spinnerLines: 1,
    }),
    TabsModule.forRoot(),
    BsDatepickerModule.forRoot(),
    NgxMaterialTimepickerModule,
    InputMaskModule.forRoot({ inputSelector: 'input', isAsync: true }),
    NgSelectModule,
    InfiniteScrollModule, // 👈 Add this
  ],
  exports: [
    ItemSliderComponent,
    LoaderComponent,
    LiveAuctionComponent,
    AuctionCardComponent,
    TableContentComponent,
    BackButtonComponent,
    AuctionDetailsHeroSkeletonComponent,
    AuctionVehicleCardComponent,
    TimedIndividualAuctionDetailsComponent,
    CutomLoaderComponent,
    InputLoaderComponent,
    DownArrowComponent,
    InfiniteScrollComponentComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ComponentsModule {}
